const removeSymbolsOfString = (value: string): string => {
  return value.replace(/\D/g, '');
};

export default removeSymbolsOfString;
